// extracted by mini-css-extract-plugin
module.exports = {"QuickReply":"QuickReply_QuickReply__1vWzB","VerticalButtons":"QuickReply_VerticalButtons__2ERsM"};